class stats {
  constructor() {
    this.level  = 0
    this.startYY= 0
    this.startMM = 0
    this.endYY = 0
    this.endMM = 0
    this.cc = ""
    this.tt = ""
    this.mm = ""
    this.rcode = ""
    this.region = ""
    this.display = ""
    this.cerFamAge = 0
    this.cerFamAgeNat = 0

  }
  startDate(){
    let startDate = this.startYY+this.startMM.toString().padStart(2, "0")
    return startDate
  }
  endDate(){
    let endDate = this.endYY+this.endMM.toString().padStart(2, "0")
    return endDate
  }
}

export default {
  stats: stats,
};